export function buildFlexPackAssignmentModalPayload({
  flexPack,
  organization,
  reloadAssignments,
}) {
  const normalizedFlexPack = {
    ...flexPack,
    flexPackMode: true,
    includeTax: false,
    additionalFees: 0,
    estimatedCombinedRate: 0,
    events: Array.from({ length: Number(flexPack?.gameTickets) || 1 }, () => ({
      id: null,
    })),
    pricingTiers: [
      {
        id: `flex-${flexPack?.id}`,
        name: 'Flex Pack',
        price: Number(flexPack?.price || 0),
      },
    ],
    organizationUUID: flexPack?.organizationUUID || organization?.uuid,
    organization: flexPack?.organization || organization,
    currency:
      flexPack?.currency ||
      flexPack?.organization?.currency ||
      organization?.currency,
    price: Number(flexPack?.price || 0),
  }

  const payload = {
    eventPackage: normalizedFlexPack,
    selectedSeatIds: {
      seats: { 'flex-pack-item': true },
    },
    data: {
      seats: {
        'flex-pack-item': {
          sectionNumber: flexPack?.name || 'Flex Pack',
          rowNumber: 'PACK',
          seatNumber: `${flexPack?.gameTickets || 1} games`,
        },
      },
      sections: {},
    },
  }

  if (typeof reloadAssignments === 'function') {
    payload.reloadAssignments = reloadAssignments
  }

  return payload
}
